<template>
    <div class="group-wrapper" :style="styles">
        <div class="group-children" v-for="(child, index) in children" :key="child.uId">
            <div class="connector-op" v-show="index !== 0">
                <el-button size="mini" disabled>
                    {{ value.connector }}
                </el-button>
            </div>
            <component
                :is="child.type"
                :value="child"
                :conditionParams="conditionParams"
                :maxLevel="maxLevel"
                :hiddenDelete="onlyOneChild"
                :validation="validation"
                @change="childChange"
                @delete="childDelete(child)"
            />
        </div>
        <div class="group-operation">
            <el-button
                class="group-operator"
                v-for="op in operation"
                :key="op"
                type="primary"
                size="mini"
                icon="el-icon-plus"
                @click="operatorHandler(op)"
            >{{ op }}</el-button>
        </div>
        <i class="el-icon-circle-close group-delete" @click="deleteHandler" v-show="!hiddenDelete"></i>
    </div>
</template>

<script>
import { initChildNode } from "./util.js";
import Condition from "./Condition.vue";

export default {
    name: "Group",
    components: {
        Condition
    },
    props: ["value", "maxLevel", "conditionParams", "hiddenDelete", "validation"],
    computed: {
        level() {
            return this.value.level;
        },
        operation() {
            const ctor = this.value.connector ? [this.value.connector] : ["AND", "OR"];
            return ctor;
        },
        styles() {
            const background = ["#D8E4F0", "#ffff"][this.level - 1];
            return {
                background,
            };
        },
        children() {
            return this.value.children || [];
        },
        onlyOneChild() {
            return this.value.children.length === 1;
        }
    },
    methods: {
        operatorHandler(op) {
            const children = this.value.children || [];
            children.push(initChildNode(this.maxLevel, this.level));
            const newValue = {
                ...this.value,
                connector: op,
                children,
            };
            this.$emit("change", newValue);
        },
        deleteHandler() {
            this.$emit("delete");
        },
        childChange(child) {
            const childIdx = this.value.children.findIndex(c => c.uId === child.uId);
            const children = [...this.value.children];
            children.splice(childIdx, 1, child);
            const newValue = {
                ...this.value,
                children,
            };
            this.$emit("change", newValue);
        },
        childDelete(child) {
            const childIdx = this.value.children.findIndex(c => c.uId === child.uId);
            const children = [...this.value.children];
            children.splice(childIdx, 1);
            const newValue = {
                ...this.value,
                children,
            };
            this.$emit("change", newValue);
        },
    }
};
</script>

<style lang="less" scoped>
.group-wrapper {
    position: relative;
    padding: 16px 28px 16px 16px;
    border-radius: 4px;
}
.connector-op {
    padding: 10px 0;
}
.group-operation {
    padding: 18px 0 0;
}
.group-delete {
    font-size: 16px;
    position: absolute;
    top: 0;
    right: -21px;
    &::before {
        color: #7A7E8E;
    }
}
</style>
